import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  createRef,
} from "react";
import QrReader from "react-qr-reader";
import blogFetch from "../../../../axios/config";
import Button from "@mui/material/Button";
import Context from "../../../../context/Context";
import { Modal, Form } from "react-bootstrap";
import { ApontModal } from "../ApontModal";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "./styles.css";
import toast from "react-hot-toast";
import { Mo } from "react-flags-select";

const FONRO = [1, 2, 3, 4, 5, 6];
const FORNO_COM_TEMPERATURA = "Forno S";

export const QrCodeReader = ({
  vagaoItens,
  // status,
  takePhoto,
  vagao_Serial,
  setTakePhoto,
  setImageUrl,
  imageUrl,
}) => {
  const {
    // getConfirmedWagon
    selectedFurnace,
    disableButton,
    status,
    setStatus,
    furnace,
    setConfirmedWagon,
    setLoading,
    modelModal,
  } = useContext(Context);

  const [startScan, setStartScan] = useState(false);
  const [loadingScan, setLoadingScan] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [showApont, setShowApont] = useState(false);
  const [cabineSelected, setCabineSelected] = useState(null);
  const [cabineSelectedHistory, setCabineSelectedHistory] = useState(null);
  const [statusApontamento, setStatusApontamento] = useState("");
  const [apontButtonEnabled, setapontButtonEnabled] = useState(true);
  const [cabinesInUse, setCabinesInUse] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [objVagao, setObjVagao] = useState(false);
  const [temperaturaEntrada, setTemperaturaEntrada] = useState("");

  const exibeTemperatura = status === "LIBERADO" && selectedFurnace === FORNO_COM_TEMPERATURA;

  useEffect(() => {
    let timer;
    if (showSpinner) {
      timer = setTimeout(() => {
        setShowSpinner(false);
      }, 2000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [showSpinner]);

  useEffect(() => {
    getCabines();
  }, []);

  const dropDown = () => {
    const filteredFurnace = furnace.some(
      (item) => selectedFurnace === item.forno_Name && item.forno_QtdCabines > 0
    );
    return filteredFurnace;
  };

  const dropDownCabines = () => {
    if (!furnace || !selectedFurnace) {
      return [];
    }
    const filteredFurnace = furnace.filter(
      (item) => selectedFurnace === item.forno_Name
    );
    if (filteredFurnace.length === 0) {
      return [];
    }
    const qtdCabines = filteredFurnace.map((item) => item.forno_QtdCabines);
    if (qtdCabines.length > 0) {
      const maxCabines = qtdCabines[0];
      const cabinesArray = Array.from({ length: maxCabines }, (_, i) => i + 1);
      if (!cabinesInUse) {
        return cabinesArray;
      }
      const cabinesInUseForSelectedFurnace = cabinesInUse
        .filter((cabine) => cabine.vagao_Serial === selectedFurnace)
        .map((cabine) => parseInt(cabine.forno_Cabine));
      const availableCabines = cabinesArray.filter(
        (cabine) => !cabinesInUseForSelectedFurnace.includes(cabine)
      );

      return availableCabines;
    }
    return [];
  };

  const getCabines = async () => {
    try {
      const { data } = await blogFetch.get(
        "/ISAGA_VagoesFornosPecas/pieces-in-cabine"
      );
      formatCabineInUse(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const formatCabineInUse = (vagoes) => {
    const updateVagoes = vagoes.map((vagao) => ({
      ...vagao,
      vagao_Serial: `Forno ${vagao.vagao_Serial[0]}`,
    }));

    setCabinesInUse(updateVagoes);
  };

  const getConfirmedWagon = async (status, selectedFurnace) => {
    setLoading(true);
    try {
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas?status=${status}&furnace=${selectedFurnace}`
      );
      const url = data.map((item) => {
        if (item.wagonInfo.vagao_Image)
          item.wagonInfo.vagao_Image +=
            "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D";
        return item;
      });
      setConfirmedWagon(url);
    } catch {
      console.error("Error");
    } finally {
      setLoading(false);
    }
  };

  const putApontamento = async (
    scanData,
    status,
    cabineSelected,
    cabineSelectedHistory
  ) => {
    const nro_matricula = JSON.parse(localStorage.getItem("user"));
    const userSAPMatricula = nro_matricula["user_SAPMatricula"];
    if (scanData) {
      setShowQR(false);
    }
    setLoadingScan(true);
    const statusOut = {
      LIBERADO: "ENTRADA",
      // ENTRADA: "CURVANDO",
      ENTRADA: "FINALIZADO",
      FINALIZADO: "APROVADO",
    };
    try {
      if (scanData && vagao_Serial === scanData) {
        const formData = new FormData();
        if (takePhoto) {
          formData.append("entryFile", takePhoto.url);
        }
        formData.append("Vagao_Key", Number(scanData.replace(/^.| /g, "")));
        formData.append("Status", statusOut[status]);
        formData.append("Status_Peca", statusOut[status]);
        formData.append("Forno_Cabine", cabineSelected);
        formData.append("Forno_CabineHistorico", cabineSelectedHistory);
        formData.append("userSAPMatricula", userSAPMatricula);
        if (exibeTemperatura && temperaturaEntrada) {
          formData.append("Temperatura_Entrada", temperaturaEntrada);
        }

        await blogFetch.put(`/ISAGA_VagoesFornos/status`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        setapontButtonEnabled(true);
        setTakePhoto({
          url: null,
          vagaoKey: 0,
        });
        setImageUrl(null);
        setCabineSelected("");
        setTemperaturaEntrada("");
        setLoadingScan(false);
        getConfirmedWagon(status, selectedFurnace);
      }
    } catch {
      console.error("error");
    }
  };

  const handleApontamento = (
    vagao_Serial,
    status,
    cabineSelected,
    cabineSelectedHistory
  ) => {
    const result = vagaoItens.filter(
      (item) => item.molde_QtdPassagens === item.molde_QtdPassagensMAX - 1
    );

    if (result.length > 0) {
      // Armazena todos os moldes lotes no estado
      setObjVagoes(result.map((item) => item.molde_Lote));
      setOpenModal(true);

      // Armazena os dados para serem usados no fechamento do modal
      setPendingApontamento({
        vagao_Serial,
        status,
        cabineSelected,
        cabineSelectedHistory,
      });
    } else {
      putApontamento(
        vagao_Serial,
        status,
        cabineSelected,
        cabineSelectedHistory
      );
    }
  };

  const [pendingApontamento, setPendingApontamento] = useState(null);
  const [objVagoes, setObjVagoes] = useState([]); // Alterado para armazenar múltiplos lotes

  const closeModal = () => {
    setOpenModal(false);

    // Se houver um apontamento pendente, faz o PUT
    if (pendingApontamento) {
      putApontamento(
        pendingApontamento.vagao_Serial,
        pendingApontamento.status,
        pendingApontamento.cabineSelected,
        pendingApontamento.cabineSelectedHistory
      );

      setPendingApontamento(null);
    }
  };

  return (
    <>
      {dropDown() && status === "LIBERADO" && (
        <DropdownButton
          className="me-3"
          id="dropdown-basic-button"
          title={cabineSelected ? cabineSelected : "Selecione uma cabine"}
        >
          {dropDownCabines().map((cabine, index) => (
            <Dropdown.Item
              onClick={() => {
                setCabineSelected(cabine);
                setCabineSelectedHistory(cabine);
              }}
              key={index}
              eventKey={cabine}
            >
              {cabine}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      )}

      {exibeTemperatura && (
        <Form.Control
          className="me-3 mb-3"
          style={{ width: 170 }}
          type="number"
          inputMode="decimal"
          step="0.1"
          placeholder="Temperatura (°C)"
          value={temperaturaEntrada}
          onChange={({ target }) => setTemperaturaEntrada(target.value)}
        />
      )}

      <Button
        className="mb-3"
        // onClick={status === "FINALIZADO" ? () => { handleApontamento(vagao_Serial); setapontButtonEnabled(false); } : () => { putApontamento(vagao_Serial, status, cabineSelected, cabineSelectedHistory); setapontButtonEnabled(false); }}
        onClick={() =>
          handleApontamento(
            vagao_Serial,
            status,
            cabineSelected,
            cabineSelectedHistory
          )
        }
        variant="contained"
        disabled={
          (takePhoto.url?.name != vagao_Serial && status === "LIBERADO") ||
          !apontButtonEnabled
        }
      >
        {!startScan && "APONTAR"}
      </Button>

      <ApontModal
        vagaoItens={vagaoItens}
        showApont={showApont}
        setShowApont={setShowApont}
        status={status}
        setapontButtonEnabled={setapontButtonEnabled}
      />

      <Modal show={openModal} onHide={closeModal} centered>
        <Modal.Body className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex flex-col items-center">
            <h2 className="text-red-600 font-extrabold text-2xl text-center mb-4">
              Última passagem dos moldes
            </h2>

            <div className="w-full bg-red-100 p-4 rounded-lg shadow-inner">
              <ul className="list-none text-red-700 font-semibold text-lg text-center space-y-2">
                {objVagoes.map((lote, index) => (
                  <li
                    key={index}
                    className="bg-white py-2 px-4 rounded-md shadow-sm"
                  >
                    {lote}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Modal.Body>
        

        <Modal.Footer className="border-none flex justify-center">
          <Button
              style={{width: "100%", backgroundColor: "#dc2626", color: "white", fontWeight: "bold" }}
              className="w-2/3 bg-red-600 hover:bg-red-700 text-white font-bold text-lg py-3 rounded-full transition duration-300 shadow-lg transform hover:scale-105 active:scale-95"
              onClick={closeModal}
            >
              Fechar
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
